import { ReactNode } from "react";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";

export function BuyerOnly(props: { children?: ReactNode }) {
  const { business } = useSellarCurrentBusiness();

  if (business?.Retailer) return <>{props.children}</>;
  return null;
}
